import { Sounds } from './MusicManager'

export default class ConsoleLogger
{
	private static IsActive() : boolean
	{
		return process.env.NODE_ENV !== 'production' || (document as any).MVPLogging === true
	}

	private static ProcessArgs(args: any[]) : string[]
	{
		return args.map((it) => {
			if (typeof it === 'string') {
				return it
			}
			if (typeof it === 'object') {
				return JSON.stringify(it, null, 2)
			}
			return `${it}`
		})
	}

	static Log(tag: string, ...args: any[])
	{
		if (ConsoleLogger.IsActive()) {
			// eslint-disable-next-line no-console
			console.log(`[${tag}]`, ...ConsoleLogger.ProcessArgs(args))
		}
	}

	static Lelele(...args: any[])
	{
		ConsoleLogger.Log('MVPLelele', ...args)
	}

	static WS(...args: any[])
	{
		ConsoleLogger.Log('MVPWS', ...args)
	}

	static Agora(...args: any[])
	{
		ConsoleLogger.Log('MVPAgora', ...args)
	}

	static MusicManager(sound: Sounds, volume: number)
	{
		ConsoleLogger.Log('MVPMusicManager', `Sound.${sound} [volume: ${volume}]`)
	}

	static Network(...args: any[])
	{
		ConsoleLogger.Log('MVPNetwork', ...args)
	}
}
